import { Component, forwardRef, Input } from "@angular/core";
import { foldInOut } from "src/app/animations";
import { Question } from "src/app/classes/dynamic-form";
import { QuestionBuilderComponent } from "./question-builder.component";


@Component( {
	standalone: true,
	selector: "question-builder-branch",
	templateUrl: "./question-builder-branch.component.html",
	styleUrl: "./question-builder-branch.component.scss",
	animations: [ foldInOut ],
	imports: [ 
		forwardRef( () => QuestionBuilderComponent ), 
	]
})
export class QuestionBuilderBranchComponent {


	@Input() branch: Question[] = [];


	constructor() {}


}